import React, { useState, useEffect } from "react";
import { ReactSVG } from "react-svg";
import { motion } from "framer-motion";
import {
  Icon,
  IconColorStyle,
  IconSize,
  MemoizedSummary,
  ISummaryFieldConfig,
  formatString,
  StringFormats,
  useFlowData,
  getFlowDataDirect,
} from "@adaptis/flow-components";
import { getPaymentFrequencyLabel } from "../../util/data-store";
import {
  ICoveredPetProps,
  CoveredPetStatus,
  CoveredPetSummaryMode,
  CoveredPetAction,
} from "./CoveredPet.types";

import "./CoveredPet.scss";

import _ from "lodash";
import { CoverType } from "../../util/common-types";
import { ReactSVGWrapper } from "../WrapperComponent";

export default function CoveredPet(props: ICoveredPetProps) {
  const { setData, getData, getDataFromArray } = useFlowData();
  const [isHovered, setIsHovered] = useState(false);
  const [hasCoupon, setHasCoupon] = useState<boolean>(false);
  let transferQuote = getFlowDataDirect("TransferQuoteCallBack") === "Yes";
  transferQuote = false;

  useEffect(() => {
    const pets = getData("pets");
    const pet = pets ? pets.find((p: any) => p.id === props.id) : null;

    const cover = pet?.customCover ?? null;
    if (cover?.promo) {
      setHasCoupon(true);
    }else{
      setHasCoupon(false);
    }
  });

  function getProductMessage() {
    if (props.status === CoveredPetStatus.Incomplete) {
      return "Incomplete";
    }
  }

  function getFirstMonthDiscounted(data: any): number {
    // Tìm đối tượng có giai đoạn chứa tháng đầu tiên (from = 1)
    const firstPeriod = data.find((item: any) => item.from === 1);

    if (!firstPeriod) {
      console.log("Not found period start from month 1");
      return -1;
    }

    // Tổng số tiền cần trả trong giai đoạn
    const { totalPayable, totalBaseAmount, from, to } = firstPeriod;

    // Tính số tiền cần trả cho tháng đầu tiên
    // return totalPayable / totalMonths;
    return totalPayable;
  }


  function getProductSummaryAmount() {
    if (props.status === CoveredPetStatus.Incomplete) return null;

    const pets = getData("pets");
    const pet = pets ? pets.find((p: any) => p.id === props.id) : null;
    if (!pet?.coverType || props.paymentFrequency === undefined) return null;

    const cover = pet.coverType === CoverType.Top ? pet.topCover : pet.customCover;
    if (!cover) return null;
    const sumDiscountedPrice = cover?.premiums?.totalPayable ?? 0;
    let sumFirstMonthPrice = 0;
    if (['2', 'type2'].includes(cover?.promo?.promoType?.toString().toLowerCase())) {
      sumFirstMonthPrice = getFirstMonthDiscounted(
        cover?.promo?.policyPremiumInstallmentPayments ?? []
      );
    }else{
      sumFirstMonthPrice = sumDiscountedPrice/12;
    }

    let installmentAmount = sumDiscountedPrice;
    switch (props.paymentFrequency) {
      case "Monthly":
        installmentAmount = Math.max(sumFirstMonthPrice, 0);
        break;
      case "Fortnightly":
        installmentAmount = (Math.max(sumFirstMonthPrice, 0) * 12) / 26.07;
        break;
    }

    return (
      <div className="product-price-wrapper">
        <div className={`product-message-type-and-price ${hasCoupon ? 'green' : ''}`}>
          {formatString(installmentAmount, StringFormats.Currency)}
        </div>
        <div className="product-message-frequency">
          per {getPaymentFrequencyLabel(props.paymentFrequency.toLowerCase())}
        </div>
      </div>
    );
  }

  function getSummaryFields(): Array<ISummaryFieldConfig> {
    let result: Array<ISummaryFieldConfig> = [];
    let pet = getDataFromArray("pets", "id", props.id);
    let dataPrefix =
      pet.coverType === CoverType.Top ? "topCover." : "customCover.";

    let petAgeOnStartDatePolicy = pet.petAgeOnStartDatePolicy || 0;
    let showExtraSummary = petAgeOnStartDatePolicy > 1094 ? false : true;

    if (props.summaryItems) {
      props.summaryItems.forEach((item) => {

        if (showExtraSummary || item.dataField !== "optionalExtras") {
          result.push({
            label: item.label,
            staticText: item.staticText,
            dataField: ["startDate"].includes(item.dataField ?? "")
              ? item.dataField
              : item.dataField
                ? dataPrefix + item.dataField
                : undefined,
            format: item.format,
          });
        }

      });
    }
    return result;
  }

  const bounceTransition = {
    y: {
      duration: 0.4,
      repeatType: "reverse",
      repeat: Infinity,
      ease: "easeOut",
    },
  };

  return (
    <div
      data-testid="CoveredPet"
      // className={"flc_covered-pet " + props.className + " " + props.status}
      className={"flc_covered-pet " + props.className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="top-row">
        <ReactSVGWrapper className="icon" src={"images/" + props.animal + ".svg"} />
        <div className="title">          
          <h5 title={props.title}>{props.title}</h5>
          {!transferQuote && (
            <a
              href=""
              className="remove-pet"
              onClick={(e) => {
                e.preventDefault();
                props.onActionClick &&
                  props.onActionClick(
                    CoveredPetAction.Delete,
                    props.id,
                    props.title
                  );
              }}
            >
              Remove this pet
            </a>
          )}
          {
            props.status !== CoveredPetStatus.Configured ? (
              <span className="coverage-status">
                {/* <span className="coverage-status__icon coverage-status__icon--alert" aria-hidden>!</span> */}
                <span className="coverage-status__icon coverage-status__icon--alert" >
                  <img className="coverage-status__check-svg" src="images/alert.svg" alt="" />
                </span>
                <span className="coverage-status__label">Choose Coverage</span>
              </span>
            ) : (
              <span className="coverage-status selected">
                {/* <span className="coverage-status__icon coverage-status__icon--check">
                  <ReactSVGWrapper className="coverage-status__check-svg" src="images/icons/check.svg" />
                </span> */}
                <span className="coverage-status__icon coverage-status__icon--check">
                  <img className="coverage-status__check-svg" src="images/check.svg" alt="" />
                </span>
                <span className="coverage-status__label">Coverage Selected</span>
              </span>
            )
          }
        </div>

        {getProductSummaryAmount()}

        {props.status != CoveredPetStatus.Configured &&
          props.summaryMode === CoveredPetSummaryMode.Link && (
            <>
              {props.status && (
                <motion.div
                  transition={bounceTransition}
                  animate={{
                    y: ["10%", "-10%"],
                  }}
                >
                  <Icon
                    src="images/icons/chevron-right.svg"
                    colorStyle={IconColorStyle.PrimaryButton}
                    colorStyleHover={IconColorStyle.PrimaryButtonHover}
                    size={IconSize.Large}
                    onClick={() =>
                      props.onActionClick &&
                      props.onActionClick(CoveredPetAction.Edit, props.id)
                    }
                  />
                </motion.div>
              )}
            </>
          )}
      </div>
      {/* {props.status !== CoveredPetStatus.Untouched &&
        props.status !== CoveredPetStatus.Configured && (
          <div className={"product-message " + props.status}>
            {getProductMessage()}
          </div>
        )} */}

      {props.status == CoveredPetStatus.Configured && (
        <>
          <div className="summary-spacer " />
          <MemoizedSummary
            stepSlug={""}
            step={props.step}
            getDataFromArray={true}
            arrayDataField="pets"
            arrayKeyField="id"
            arrayKey={props.id}
            labelColWidth={60}
            summaryConfig={getSummaryFields()}
            petAgeCategory={props.petAgeCategory}
          />
          {!transferQuote && (
            <div>
              <span
                onClick={() =>
                  props.onActionClick &&
                  props.onActionClick(CoveredPetAction.Edit, props.id)
                }
              >
                Edit
                <Icon
                  src="images/icons/edit-2.svg"
                  colorStyle={IconColorStyle.Custom}
                  colorStyleHover={IconColorStyle.Custom}
                  size={IconSize.Small}
                />
              </span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
